import React from 'react';
import { Box, Chip, ChipProps, Grid, Paper, styled } from '@mui/material';
import { AvailStatus } from '@/components/_common/Table/Calendar/Calendar.types';
import { useAppSelector } from '@/redux/hooks';
import { selectSelectedAvailId } from '@/redux/selectors/focusCalendarSelectors';
import { getAvailBgColorByStatus } from '@/components/_common/Table/Calendar/utils';
import { FocusTheme } from '@/components/Focus/configs/theme';

export const AvailChip = styled(Chip)`
  font-size: 1rem;
`;

export const LicenseChip = (props: ChipProps) => {
  return <AvailChip variant="outlined" sx={{ color: 'tertiary.main', borderColor: 'tertiary.main' }} {...props} />;
};

interface GridViewAvailProps {
  children: React.ReactNode;
  availId: number;
  status: AvailStatus;
}

export const GridViewAvail: React.FC<GridViewAvailProps> = ({ children, availId, status }) => {
  const selectedAvailId = useAppSelector(selectSelectedAvailId);
  const isSelected = availId === selectedAvailId;
  const backgroundColor = getAvailBgColorByStatus(status);
  return (
    <GridViewAvailStyled container alignItems="center" gap={1} sx={{ backgroundColor: isSelected ? backgroundColor : undefined }}>
      {children}
    </GridViewAvailStyled>
  );
};

const GridViewAvailStyled = styled(Grid)`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
  background-color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.background};
  color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.highlight};
  cursor: pointer;
`;

export const Bullet = styled(Box)`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
`;

export const StyledPaper = styled(Paper, { shouldForwardProp: (propKey: string) => !['big'].includes(propKey) })<{ big?: boolean }>`
  flex-grow: 1;
  padding: ${({ theme, big }) => theme.spacing(big ? 2 : 1, 2)};
  background-color: ${({ theme }) => theme.palette.background.paper};
`;
